var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "loader-feedback" }, [
    _c("span", {
      staticClass: "loader-feedback__title",
      domProps: {
        textContent: _vm._s(
          _vm.translate("scheduler.modal.parameters.data.set.label")
        ),
      },
    }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "loader-feedback__input" },
      [
        _c("mds-loader", {
          staticClass: "loader-feedback__loader",
          attrs: { size: "small" },
        }),
        _vm._v(" "),
        _c("span", {
          staticClass: "loader-feedback__description",
          domProps: {
            textContent: _vm._s(_vm.translate("scheduler.input.loading")),
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }